import { render, staticRenderFns } from "./bindAcctWay.vue?vue&type=template&id=c86eabac"
import script from "./bindAcctWay.vue?vue&type=script&lang=js"
export * from "./bindAcctWay.vue?vue&type=script&lang=js"
import style0 from "./bindAcctWay.vue?vue&type=style&index=0&id=c86eabac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports